import React from 'react';
import styled from 'styled-components';

const PriceDetailsWrapper = styled.div`
  .PriceDetails {
    &-item {
      display: grid;
      color: var(--dark-grey-color);
      grid-template:
        'text numb'
        / 1fr 92px;
    }

    &-text {
      color: #000;
      text-align: left;
      grid-area: 'text';
      padding: 10px 5px 10px 12px;
      font-size: 12px;
      line-height: 1.4;
      display: inline-block;
    }

    &-number {
      grid-area: 'numb';
      font-size: 13px;
      padding: 6px 15px 6px 0px;
      font-weight: 900;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }

    &-check {
      &:after {
        content: '';
        display: block;
        width: 5px;
        height: 12px;
        border: solid var(--light-blue-color);
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
        position: relative;
        top: -1px;
      }
    }

    &-container {
      border-radius: 3px;
      background-color: var(--white-color);
      border-bottom: 4px solid var(--blue-color);
    }

    &-container .PriceDetails-item:nth-child(even) {
      background-color: #eee;
    }
  }
`;

const Item = ({ title }) => (
  <div className="PriceDetails-item">
    <div className="PriceDetails-text">{title}</div>
    <div className="PriceDetails-number">
      <span className="PriceDetails-check"></span>
    </div>
  </div>
);

const PriceDetails = ({ disease }) => (
  <PriceDetailsWrapper>
    <div className="PriceDetails-container">
      {disease === 0 && <Item title="Evento cerebrovascular" />}
      {disease === 0 && <Item title="Insuficiencia renal crónica" />}
      {disease === 0 && <Item title="Quemaduras graves" />}
      {disease === 0 && <Item title="Trasplante de órganos" />}
      {disease === 0 && <Item title="Cirugía cardíaca" />}
      {disease >= 0 && <Item title="Cáncer" />}
      {disease === 0 && <Item title="Politraumatismo severo" />}
      {disease === 1 && (
        <Item title="Diagnóstico Primario para cualquier tipo" />
      )}
    </div>
  </PriceDetailsWrapper>
);

export default PriceDetails;
